import { ContactPhoneOutlined } from '@material-ui/icons';

const obj = {
  one: {
    second: {
      checkThis: 'a',
      third() {
        console.log(this);

        function name() {
          console.log(this);
        }
        name();
      }
    }
  }
};

const a = {
  x: 'qwe'
};

var foo = { n: 1 };
var bar = foo;
foo.x = foo = 1;

console.log(foo.x);

const arr = [1, 2, 3, 4, 5, 1, 7, 2];

// console.log(arr.indexOf(1));
// const result = new Set(arr);
const result = arr.reduce((acc, currentVal, index, array) => {
  return array.indexOf(currentVal) === index ? acc.concat(currentVal) : acc;
}, []);
// for (let i = 0; i < arr.length; i++) {
//   console.log(arr.indexOf(arr[i]) === i);
//   //   console.log(arr[i]);
//   if (arr.indexOf(arr[i]) === i) {
//     result.push(arr[i]);
//   }
// }

console.log(result);

// const func1 = () => {
//   console.log('arrow', this);
//   const funcInFunc1 = () => {
//     console.log('arrowinarrow', this);
//   };

//   funcInFunc1();
// };

// function func2() {
//   console.log('simple', this);
//   const funcInFunc2 = () => {
//     console.log('arrowInSimple', this);
//   };

//   funcInFunc2();
// }

// func1();
// func2();

(function(x) {
  //   console.log(y);
  return (function(y) {
    console.log(x);
  })('y');
})('x');

export default obj;
